import { CARD_NETWORK_LOGO_WIDTH } from "../cardProgramDesignConstants";

const LOGO_VIEWBOX_WIDTH = 98;
const LOGO_VIEWBOX_HEIGHT = 84;

export const CardMastercardHologramLogo = ({
  lightBg = false,
  variant = "monochrome",
  width = CARD_NETWORK_LOGO_WIDTH,
}) => {
  const isBrand = variant === "brand";
  const fill = isBrand ? "#231F20" : lightBg ? "#1a1a1a" : "#ffffff";
  const opacity = isBrand ? 1 : lightBg ? 0.72 : 0.9;
  const height = Math.round((width * LOGO_VIEWBOX_HEIGHT) / LOGO_VIEWBOX_WIDTH);

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${LOGO_VIEWBOX_WIDTH} ${LOGO_VIEWBOX_HEIGHT}`}
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className="block h-auto w-auto max-w-full shrink-0"
      style={{ display: "block", aspectRatio: `${LOGO_VIEWBOX_WIDTH} / ${LOGO_VIEWBOX_HEIGHT}` }}
    >
      {isBrand ? (
        <>
          <circle cx="36" cy="27" r="21.5" fill="#EB001B" />
          <circle cx="58" cy="27" r="21.5" fill="#F79E1B" />
          <path
            d="M47 10.5a16.5 16.5 0 0 0 0 33a16.5 16.5 0 0 0 0-33z"
            fill="#FF5F00"
          />
        </>
      ) : (
        <>
          <circle cx="36" cy="27" r="21.5" fill={fill} fillOpacity={opacity} />
          <circle cx="58" cy="27" r="21.5" fill={fill} fillOpacity={opacity * 0.82} />
        </>
      )}
      <text
        x="47"
        y="66"
        textAnchor="middle"
        fill={isBrand ? "#ffffff" : fill}
        fillOpacity={isBrand ? 0.95 : opacity}
        fontSize="13.5"
        fontWeight="500"
        fontFamily="'Mark Offc For MC', 'Segoe UI', system-ui, sans-serif"
        letterSpacing="0.04em"
      >
        mastercard
      </text>
      <text
        x="78"
        y="62"
        fill={isBrand ? "#ffffff" : fill}
        fillOpacity={isBrand ? 0.9 : opacity * 0.9}
        fontSize="7"
        fontFamily="system-ui, sans-serif"
      >
        ™
      </text>
    </svg>
  );
};
